export var APP_SET_APP_FETCHING_STATUS = 'APP_SET_APP_FETCHING_STATUS';
export var APP_SET_APP = 'APP_SET_APP';
export var APP_SET_APP_FIELD_VALUE = 'APP_SET_APP_FIELD_VALUE';
export var APP_SET_SESSION_FETCHING_STATUS = 'APP_SET_LAST_SESSION_FETCHING_STATUS';
export var APP_SET_SESSION = 'APP_SET_SESSION';
export var APP_SET_LAST_SESSION = 'APP_SET_LAST_SESSION';
export var APP_SET_LAST_SESSION_NOT_FOUND = 'APP_SET_LAST_SESSION_NOT_FOUND';
export var APP_EDIT_LAST_SESSION_FIELD = 'APP_EDIT_LAST_SESSION_FIELD';
export var APP_CLEAR = 'APP_CLEAR';